/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { BadgeDirective } from '@ng-falcon/badge/badge.directive';
import {
  TESTER_NAVIGATION_HEADER_SERVICE,
  TesterNavigationHeaderService,
} from '../tester-navigation-header.service';

@Component({
    selector: 'ngf-tester-navigation-header-notifications',
    templateUrl: './tester-navigation-header-notifications.component.html',
    styleUrls: ['./tester-navigation-header-notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [BadgeDirective]
})
export class TesterNavigationHeaderNotificationsComponent implements OnInit {
  @Input() notificationsUrl = '/activity';

  unreadCount = 0;
  hasUnread = false;

  /**
   * FLO-54052/FLO-54098: the tester-app points this at the uTest activity page, which moves to
   * `https://<tester host>/utest/activity` — a same-origin absolute URL that the host app's AngularJS
   * `html5Mode` link rewriting would otherwise swallow, leaving the bell as a dead click.
   */
  get externalHrefTarget(): string | null {
    return /^https?:\/\//.test(this.notificationsUrl) ? '_self' : null;
  }

  get displayCount(): number | string {
    return this.unreadCount > 9 ? '9+' : this.unreadCount;
  }

  get ariaLabel(): string {
    if (!this.hasUnread || this.unreadCount === 0) {
      return 'Notifications';
    }
    return `Notifications, ${this.unreadCount} unread`;
  }

  constructor(
    @Inject(TESTER_NAVIGATION_HEADER_SERVICE) private navHeaderService: TesterNavigationHeaderService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.navHeaderService.getUnreadActivities().then((activities) => {
      this.unreadCount = activities.count;
      this.hasUnread = activities.hasUnread;
      this.cdr.markForCheck();
    });
  }

  clearUnread(): void {
    this.unreadCount = 0;
    this.hasUnread = false;
    this.cdr.markForCheck();
  }
}
